export enum MediaMaxWidth {
  Mobile = 480, // Media Query for Mobile Devices
  TabletAndIpad = 767, // Media Query for low resolution  Tablets, Ipads
  TabletAndIpadPortraitMode = 1024, // Media Query for Tablets Ipads portrait mode
  LaptopAndDesktop = 1280, // Media Query for Laptops and Desktops
}
